import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DecorativeSquares from "../../ui/DecorativeSquares";
import { FiPhoneCall } from "react-icons/fi";
import dishImg from "../../../assets/images/imgLibrary/03.png";
import { GoSun, GoMoon } from "react-icons/go";
import { SlCalender } from "react-icons/sl";
import orderdish from "../../../assets/images/svgs/cards/orders.svg";
import { CiLocationOn } from "react-icons/ci";
import PrimaryBtn from "../../button/PrimaryBtn";
import { useDispatch, useSelector } from "react-redux";
import CompleteOrderShimmer from "../../Preloader/CompleteOrderShimmer";
import { addOrupdatePlanOrder } from "../../../redux/thunks/deiverAnorderThunk";
import NewPlanadded from "../../Modals/NewPlanadded";
import toast from "react-hot-toast";

const CompleteSubscribe = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { subscribeDraft } = useSelector((state) => state.subscribeDraft);
  const { isPlanLoading } = useSelector((state) => state.planSlice);
  const [planAdded, setPlanAdded] = useState(false);
  if (!subscribeDraft) {
    return <p className="text-center mt-8">No order details available</p>;
  }

  const toYYYYMMDD = (date) => {
    const d = new Date(date);
    return d.toISOString().split("T")[0];
  };

  const DAY_TO_NUMBER = {
    monday: "1",
    tuesday: "2",
    wednesday: "3",
    thursday: "4",
    friday: "5",
    saturday: "6",
    sunday: "7",
  };

  const buildPayload = () => ({
    service_provider_customer_id:
      Number(subscribeDraft.customer.id) ||
      Number(subscribeDraft.customer.selectedCustomerId),
    meal_id: subscribeDraft.meal.id,
    meal_plan_id: subscribeDraft.meal.meal_plan_id,
    plan_type: subscribeDraft.order.planType.toLowerCase(),
    meal_timing: subscribeDraft.order.mealTiming.toLowerCase(),
    start_date: toYYYYMMDD(subscribeDraft.order.date),
    meal_quantity: subscribeDraft.meal.qty,
    delivery_preference: subscribeDraft.order.deliveryType,
    ...(subscribeDraft.order.deliveryType === "delivery" && {
      sp_customer_address_id: subscribeDraft.addressId,
    }),

    total_amount: Number(subscribeDraft.meal.subscriptionCost).toFixed(2),
    extra_items: subscribeDraft.extra_Item,

    ...(subscribeDraft.order.planType === "monthly" && {
      delivery_days: subscribeDraft.order.deliveryDays.map(
        (day) => DAY_TO_NUMBER[day],
      ),
    }),
    time_slot: subscribeDraft.order.timeSlot,
    order_remark: subscribeDraft.orderRemark,
  });

  const handleStartSubscription = () => {
    const payload = buildPayload();
    // console.log("The payload is :", payload);

    dispatch(addOrupdatePlanOrder(payload))
      .unwrap()
      .then((res) => {
        // console.log("Thunk response:", res);

        if (res.success === false) {
          toast.error(res.message || "Plan not added");
          return;
        }

        toast.success(res.message || "Plan added successfully");
        setPlanAdded(true);
        localStorage.setItem("isToday", res.data.isToday);
      })
      .catch((err) => {
        toast.error(err || "Something went wrong");
      });
  };

  const address = subscribeDraft.address;

  const handleOpenMap = () => {
    if (!address?.latitude || !address?.longitude) return;

    const lat = address.latitude;
    const lng = address.longitude;

    const mapUrl = `https://www.google.com/maps?q=${lat},${lng}`;

    window.open(mapUrl, "_blank");
  };

  const totalCost =
    subscribeDraft.pricing.finalAmount * subscribeDraft.meal.totalMeals;

  return (
    <section className="relative min-h-screen ">
      <DecorativeSquares />

      {isPlanLoading ? (
        <CompleteOrderShimmer />
      ) : (
        <>
          {/* Center Card Wrapper */}
          <div className=" mt-8">
            <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl  shadow-sm">
              <div className="flex items-center gap-4 p-4">
                {/* Avatar */}
                <div className="flex items-center justify-center w-12 h-12 rounded-md bg-[#FFEFEB] text-[#FF6943] font-semibold">
                  {subscribeDraft.customer.initials}
                </div>

                {/* User Info */}
                <div className="flex flex-col">
                  <h2 className="text-base font-semibold text-gray-900">
                    {subscribeDraft.customer.name}
                  </h2>

                  <p className="mt-1 flex items-center gap-2 text-sm text-gray-600">
                    <FiPhoneCall />
                    {subscribeDraft.customer.phone}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Main details */}
          <div className="  mt-8">
            <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
              <div className="flex items-center gap-4">
                {/* Avatar */}
                <div className="flex items-center justify-center  rounded-md bg-[#FFEFEB] text-[#FF6943] font-semibold">
                  <img
                    src={subscribeDraft.meal.image}
                    alt={subscribeDraft.meal.name}
                    className="object-cover w-12 h-12 rounded-md"
                  />
                </div>

                {/* User Info */}
                <div className="flex flex-col">
                  <h2 className="text-base font-semibold text-gray-900">
                    {subscribeDraft.meal.name}
                  </h2>

                  <p className="mt-1 flex items-center gap-2 text-sm text-[#FF6943] font-bold">
                    {subscribeDraft.currencySymbol}
                    {subscribeDraft.meal.price}
                  </p>
                </div>
              </div>
              <div className="mt-4 flex justify-start gap-4">
                <div className="rounded-full bg-[#ACA8A6]/30 w-24 p-1 px-2 flex justify-center gap-2">
                  {subscribeDraft.order.mealTiming === "Lunch" ? (
                    <GoSun size={12} />
                  ) : (
                    <GoMoon size={12} />
                  )}
                  <p className="text-xs">{subscribeDraft.order.mealTiming}</p>
                </div>
                <div className="mt-1 flex justify-center gap-2">
                  <SlCalender size={12} />
                  <p className="text-xs">{subscribeDraft.order.date}</p>
                </div>
              </div>
              <div className="border-b border-gray-200 mt-6 mb-2"></div>

              <div className="mt-4">
                {/* Order header */}
                <div className="flex justify-between gap-4">
                  <div className="flex gap-4">
                    <img src={orderdish} alt="orderDish" className="h-5 w-5 " />
                    <p className="text-gray-700 text-sm text-start font-bold">
                      {subscribeDraft.meal.qty} X {subscribeDraft.meal.name}
                    </p>
                  </div>
                  <p className="mt-1 flex items-center gap-2 text-lg text-[#FF6943] font-bold">
                    {subscribeDraft.currencySymbol}
                    {subscribeDraft.pricing.mealTotal}
                  </p>
                </div>
                {/* Order details */}
                <div className="relative -mx-4 sm:mx-0 overflow-x-auto lg:overflow-x-hidden mt-4">
                  <div className="w-full md:min-w-[640px] rounded-lg border border-gray-200 bg-white">
                    <table className="w-full text-left text-sm sm:text-base text-gray-800">
                      <thead className="bg-gray-50">
                        {subscribeDraft.extraItems?.length > 0 && (
                          <tr>
                            <th
                              colSpan={2}
                              className="py-3 px-4 text-start text-base sm:text-lg font-semibold"
                            >
                              Extra items
                            </th>
                            <th
                              colSpan={2}
                              className="py-3 px-4 text-end text-base sm:text-lg font-semibold text-[#FF6943]"
                            >
                              {subscribeDraft.currencySymbol}
                              {Number(
                                subscribeDraft.extraItems.reduce(
                                  (acc, i) => acc + Number(i.total || 0),
                                  0,
                                ),
                              ).toFixed(2)}
                            </th>
                          </tr>
                        )}
                      </thead>

                      <tbody className="divide-y">
                        {subscribeDraft.extraItems?.length > 0 &&
                          subscribeDraft.extraItems.map((item, i) => (
                            <tr key={i}>
                              <td colSpan={2} className="py-2 px-4">
                                <div className="flex items-center gap-2 whitespace-nowrap">
                                  <span className="inline-block w-2 h-2 rounded-full bg-[#FF6943]" />
                                  <span>{`${item.qty} x ${item.name}`}</span>
                                </div>
                              </td>
                              <td className="py-2 px-4 text-end font-semibold whitespace-nowrap">
                                {subscribeDraft.currencySymbol}
                                {Number(item.total).toFixed(2)}
                              </td>
                            </tr>
                          ))}

                        {/* Charges */}
                        {subscribeDraft?.order?.deliveryType === "delivery" && (
                          <tr className="bg-gray-50">
                            <th colSpan={2} className="py-3 px-4 font-semibold">
                              Delivery charges
                            </th>
                            <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                              {subscribeDraft.currencySymbol}
                              {Number(
                                subscribeDraft.pricing.deliveryCharge,
                              ).toFixed(2)}
                            </th>
                          </tr>
                        )}

                        {(() => {
                          const rawValue = Number(
                            subscribeDraft?.pricing?.adjustment || 0,
                          );

                          if (rawValue === 0) return null; // 👈 Kuch nahi dikhega

                          const isDiscount = rawValue < 0;

                          return (
                            <tr>
                              <th
                                colSpan={2}
                                className="py-3 px-4 font-semibold"
                              >
                                {isDiscount ? "Discount" : "Other Charges"}
                              </th>

                              <th
                                className={`py-3 px-4 text-end font-semibold ${
                                  isDiscount ? "text-[#1CCB50]" : "text-red-500"
                                }`}
                              >
                                {isDiscount
                                  ? `- ${subscribeDraft.currencySymbol}`
                                  : `+${subscribeDraft.currencySymbol}`}
                                {rawValue < 0
                                  ? rawValue.toFixed(2)
                                  : `+${rawValue.toFixed(2)}`}
                              </th>
                            </tr>
                          );
                        })()}

                        <tr className="bg-orange-50">
                          <th
                            colSpan={2}
                            className="py-3 px-4 font-semibold text-[#FF6943]"
                          >
                            Total Order Amount
                          </th>
                          <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                            {subscribeDraft.currencySymbol}
                            {Number(subscribeDraft.pricing.finalAmount).toFixed(
                              2,
                            )}
                          </th>
                        </tr>
                        <tr className="bg-orange-50">
                          <th
                            colSpan={2}
                            className="py-3 px-4 font-semibold text-[#FF6943]"
                          >
                            Subscription cost ({subscribeDraft.meal.totalMeals}{" "}
                            Meals)
                          </th>
                          <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                            {subscribeDraft.currencySymbol}
                            {Number(totalCost).toFixed(2)}
                          </th>
                        </tr>
                      </tbody>

                      <tfoot className="border-t bg-white">
                        <tr>
                          <th colSpan={2} className="py-3 px-4 font-medium">
                            Plan Type
                          </th>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-end font-semibold"
                          >
                            {subscribeDraft.order.planType}
                          </th>
                        </tr>
                        <tr>
                          <th colSpan={2} className="py-3 px-4 font-medium">
                            Start Date
                          </th>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-end font-semibold"
                          >
                            {subscribeDraft.order.date}
                          </th>
                        </tr>
                        <tr>
                          <th
                            colSpan={2}
                            className="py-3 px-4 font-medium text-left"
                          >
                            Meal Timing
                          </th>

                          <th colSpan={2} className="py-3 px-4 text-end">
                            <div className="flex justify-end">
                              <div className="inline-flex items-center gap-2 rounded-full bg-[#ACA8A6]/30 px-3 py-1 text-sm font-semibold capitalize">
                                {subscribeDraft?.order?.mealTiming ===
                                "lunch" ? (
                                  <GoSun size={14} />
                                ) : (
                                  <GoMoon size={14} />
                                )}

                                <span>
                                  {subscribeDraft?.order?.mealTiming || "-"}
                                </span>
                              </div>
                            </div>
                          </th>
                        </tr>
                        <tr>
                          <th colSpan={2} className="py-3 px-4 font-medium">
                            Delivery Type
                          </th>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-end font-semibold"
                          >
                            {subscribeDraft.order.deliveryType === "delivery"
                              ? "Home Delivery"
                              : "Pick up"}
                          </th>
                        </tr>
                        <tr>
                          <th colSpan={2} className="py-3 px-4 font-medium">
                            Time slot
                          </th>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-end font-semibold"
                          >
                            {subscribeDraft.order.timeSlot}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              {subscribeDraft.orderRemark && (
                <div className="mt-8 mb-4 mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-2 shadow-sm flex items-center gap-4">
                  <div className="flex flex-col p-4">
                    <div className="mb-2">
                      <h1 className="text-base font-bold text-black">
                        Order Remark
                      </h1>
                    </div>
                    <div className="mb-2 text-sm text-gray-400">
                      {subscribeDraft.orderRemark}
                    </div>
                  </div>
                </div>
              )}
              <div className="mt-4 flex justify-start gap-2">
                {subscribeDraft.address && (
                  <div
                    className="mt-4 flex justify-start gap-2 cursor-pointer"
                    onClick={handleOpenMap}
                  >
                    <CiLocationOn size={20} className="text-[#363636]" />
                    <p className="text-start text-[#363636] text-[12px] md:text-sm underline">
                      {subscribeDraft.address.fullAddress}
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="flex justify-end  mt-4">
              <PrimaryBtn
                btnName="Start Subscription"
                clickEvent={handleStartSubscription}
              />
            </div>
          </div>
        </>
      )}

      {planAdded && (
        <NewPlanadded open={planAdded} onClose={() => setPlanAdded(false)} />
      )}
    </section>
  );
};

export default CompleteSubscribe;
